import React from 'react';
import { motion } from 'framer-motion';
import { config } from '../config/config';

const Hero = () => {
  const handleCall = () => {
    window.location.href = `tel:${config.business.contact}`;
  };

  const handleWhatsApp = () => {
    const whatsappNumber = config.business.whatsapp || config.business.contact;
    window.open(`https://wa.me/91${whatsappNumber.replace(/\D/g, '')}`, '_blank');
  };

  return (
    <section className="hero" id="home">
      <div className="hero-left">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="tag">Gurugram's Trusted Gold & Silver Buyer</div>
          <h1>
            SELL
            <span>GOLD & SILVER</span>
            <span className="instant-cash">GET INSTANT CASH</span>
          </h1>
          <p>
            Premium rates for your gold and silver. <strong>We also buy mortgaged/pawned gold</strong> - we help release and purchase your mortgaged jewellery. Free home pickup within {config.business.homePickup.freeRadius}km radius. Instant cash payment. Serving Gurugram and Delhi since {config.business.yearEstablished}.
          </p>
          <div className="hero-actions">
            <button className="btn-big filled" onClick={handleCall}>
              📞 Call Now
            </button>
            <button className="btn-big empty" onClick={handleWhatsApp}>
              💬 WhatsApp
            </button>
            <a href="/query" className="btn-big empty">
              📝 Submit Query
            </a>
          </div>
        </motion.div>
      </div>
      <div className="hero-right">
        <motion.div
          className="rate-banner"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h2>OUR SERVICES</h2>
          <div className="rates">
            <div className="rate-item">
              <div>
                <div className="rate-name">🏆 Sell Gold</div>
                <div className="rate-unit">Instant cash payment</div>
              </div>
              <div className="rate-price">INSTANT</div>
            </div>
            <div className="rate-item">
              <div>
                <div className="rate-name">🪙 Sell Silver</div>
                <div className="rate-unit">Quick evaluation</div>
              </div>
              <div className="rate-price">INSTANT</div>
            </div>
            <div className="rate-item">
              <div>
                <div className="rate-name">🔓 Buy Mortgaged Gold</div>
                <div className="rate-unit">Release & purchase mortgaged jewellery</div>
              </div>
              <div className="rate-price">SPECIAL</div>
            </div>
          </div>
        </motion.div>
        <div className="bonus-strip">
          ⬆ FREE HOME PICKUP WITHIN {config.business.homePickup.freeRadius}KM RADIUS | 🔓 WE BUY MORTGAGED/PAWNED GOLD
        </div>
        <div className="hero-feats">
          {config.features.map((feat, idx) => (
            <motion.div
              key={idx}
              className="feat"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.4 + idx * 0.1 }}
            >
              <div className="feat-icon">{feat.icon}</div>
              <div>
                <div className="feat-title">{feat.title}</div>
                <div className="feat-sub">{feat.subtitle}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
